import { Injectable } from '@angular/core';
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class AppToastService {

  constructor(
    private toastrService: ToastrService,
  ) { }

  showSuccessMessage(message: string) {
    this.toastrService.success(message, "Succès");
  }

  showWarningMessage(message: string) {
    this.toastrService.warning(message, "Avertissement");
  }

  showErrorMessage(message: string, title: string = "Erreur") {
    this.toastrService.error(message, title,);
  }

  showInfoMessage(message: string) {
    this.toastrService.info(message, "Information");
  }
}
